import { useState, useEffect } from 'react';
import './LoaderOverlay.css';

export default function LoaderOverlay({ onDone }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (document.readyState === 'complete') {
      setProgress(100);
      const timeout = setTimeout(onDone, 0);
      return () => clearTimeout(timeout);
    }

    // плавный фейк до 90 %
    const fake = setInterval(() => setProgress(p => (p < 90 ? p + 1 : p)), 22);

    // FALLBACK: если onload не сработал, закрыть через 4 сек
    const failSafe = setTimeout(() => finish(), 4000);

    function finish() {
      clearInterval(fake);
      clearTimeout(failSafe);
      setProgress(100);
      setTimeout(onDone, 400); // даём бару дорисоваться
    }

    window.addEventListener('load', finish, { once: true });
    return () => { clearInterval(fake); clearTimeout(failSafe); };
  }, [onDone]);

  return (
    <div className="loader" style={{ opacity: progress === 100 ? 0 : 1 }}>
      <div className="loader-bar"><div style={{ width: `${progress}%` }} /></div>
      <div className="loader-text">[ LOADING {String(progress).padStart(3, '0')}% ]</div>
    </div>
  );
}
